"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6740],{

/***/ 68020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ SanityVideo; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var esm = __webpack_require__(68138);
;// CONCATENATED MODULE: ./hooks/useOptimizedVideoUrl.tsx

var useOptimizedVideoUrl = function(param) {
    var transformations = param.transformations, elementWidth = param.elementWidth;
    var optimizedUrl = (0,react.useMemo)(function() {
        if (!(transformations === null || transformations === void 0 ? void 0 : transformations.length)) return null;
        var eagerOptimized = transformations.filter(function(eager) {
            return eager && eager.width && eager.url;
        }).map(function(eager) {
            return {
                widthDiff: Math.abs(eager.width - elementWidth),
                url: eager.url
            };
        });
        if (eagerOptimized.length === 0) return null;
        var ref = eagerOptimized.reduce(function(prev, curr) {
            return prev.widthDiff < curr.widthDiff ? prev : curr;
        }), closestUrl = ref.url;
        return closestUrl;
    }, [
        elementWidth,
        transformations
    ]);
    return optimizedUrl;
};

// EXTERNAL MODULE: ./utils/merge.ts
var merge = __webpack_require__(57000);
// EXTERNAL MODULE: ./ui/components/Video.tsx + 1 modules
var Video = __webpack_require__(82200);
;// CONCATENATED MODULE: ./ui/components/SanityVideo.tsx









var SanityVideo = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var _$ref, _$ref1, _$ref2;
    var video = props.video, videoOptions = props.videoOptions, rest = (0,_object_without_properties/* default */.Z)(props, [
        "video",
        "videoOptions"
    ]);
    var innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return innerRef.current;
    });
    var _$ref3 = (0,esm/* useResizeObserver */.yU)(innerRef), elementWidth = _$ref3.width;
    var options = (0,react.useMemo)(function() {
        return (0,merge/* merge */.T)({
            controls: (video === null || video === void 0 ? void 0 : video.controls) === null ? false : video === null || video === void 0 ? void 0 : video.controls,
            autoPlay: (video === null || video === void 0 ? void 0 : video.autoplay) === null ? true : video === null || video === void 0 ? void 0 : video.autoplay,
            loop: (video === null || video === void 0 ? void 0 : video.loop) === null ? true : video === null || video === void 0 ? void 0 : video.loop,
            muted: (video === null || video === void 0 ? void 0 : video.mute) === null ? true : video === null || video === void 0 ? void 0 : video.mute
        }, videoOptions);
    }, [
        video,
        videoOptions
    ]);
    var optimizedVideoUrl = useOptimizedVideoUrl({
        transformations: video === null || video === void 0 ? void 0 : (_$ref = video.source) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.cloudinary) === null || _$ref1 === void 0 ? void 0 : _$ref1.transformations,
        elementWidth: elementWidth
    });
    if (!(video === null || video === void 0 ? void 0 : (_$ref2 = video.source) === null || _$ref2 === void 0 ? void 0 : _$ref2.url)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* Video */.n, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        // @ts-expect-error Type 'LegacyRef<HTMLVideoElement>' is not assignable to type 'Ref<HTMLVideoElement> | undefined'
        ref: innerRef
    }, rest), {
        videoOptions: options,
        src: optimizedVideoUrl || video.source.url
    }));
});
SanityVideo.displayName = "SanityVideo";


/***/ }),

/***/ 82200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ Video; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useOnRouterChangeStart.ts
var useOnRouterChangeStart = __webpack_require__(97491);
// EXTERNAL MODULE: ./utils/ga4VideoEvents.ts
var ga4VideoEvents = __webpack_require__(78615);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
;// CONCATENATED MODULE: ./ui/components/VideoPlayerWithGA4Events.tsx













// when import normally use this component
// this is a wrapper of VideoPlayerWithGA4Events_Child and only add the hook of pageEventContext
// NOTE: maybe in a future we can save and consume the pageviewEventHasFired with zustand
var VideoPlayerWithGA4Events = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayerWithGA4Events_Child, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        pageviewEventHasFired: pageviewEventHasFired,
        ref: ref
    }));
});
VideoPlayerWithGA4Events.displayName = "VideoPlayerWithGA4Events";
// when testing use this export
// this is the component without using pageEventContext hook so we can hardcode the pageviewEventHasFired when testing
var VideoPlayerWithGA4Events_Child = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, // ───────────────────
    pageviewEventHasFired = _param.pageviewEventHasFired, onVideoStartCallback = _param.onVideoStartCallback, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "pageviewEventHasFired",
        "onVideoStartCallback"
    ]);
    var _$ref = (0,store/* useFiredEventsStore */.xm)(), eventHasFired = _$ref.eventHasFired, setEventFired = _$ref.setEventFired;
    var _$ref1 = (0,react.useState)(0), videoCurrentTime = _$ref1[0], setVideoCurrentTime = _$ref1[1];
    var _$ref2 = (0,react.useState)(0), videoDuration = _$ref2[0], setVideoDuration = _$ref2[1];
    var _$ref3 = (0,react.useState)(-1), videoProgress = _$ref3[0], setVideoProgress = _$ref3[1];
    var _$ref4 = (0,react.useState)(""), videoUrl = _$ref4[0], setVideoUrl = _$ref4[1];
    var _$ref5 = (0,react.useState)(""), videoTitle = _$ref5[0], setVideoTitle = _$ref5[1];
    var _$ref6 = (0,react.useState)(true), firstTime = _$ref6[0], setFirstTime = _$ref6[1];
    var _$ref7 = (0,react.useState)(undefined), currentPercentage = _$ref7[0], setCurrentPercentage = _$ref7[1];
    (0,useOnRouterChangeStart/* useOnRouterChangeStart */.k)((0,react.useCallback)(function() {
        if (pageviewEventHasFired) {
            // when page start to change -> reset current local state
            // this avoid problems of fire again the events previously cleaned on pageEventContext
            setVideoProgress(-1);
            setCurrentPercentage(undefined);
            setVideoCurrentTime(0);
            setVideoDuration(0);
        }
    }, [
        pageviewEventHasFired
    ]));
    var onTimeUpdate = (0,react.useCallback)(function(e) {
        var video = e.target;
        var duration = video.duration || 0;
        var currentTime = video.currentTime || 0;
        if (duration) {
            var toFixed0 = function(value) {
                return parseInt(value.toFixed(0), 10);
            };
            var percent = toFixed0(currentTime / duration * 100);
            setVideoProgress(parseInt(String(percent), 10));
            setVideoCurrentTime(currentTime);
            if (video.currentSrc && firstTime) {
                setVideoDuration(duration);
                setVideoUrl(video.currentSrc);
                setVideoTitle(video.title);
                setFirstTime(false);
            }
        }
    }, [
        firstTime
    ]);
    (0,react.useEffect)(function() {
        // get the "current" percentage from the percentages (0, 10, 25, 50, 75, 100)
        if (pageviewEventHasFired) {
            var percentageToFire = (0,_to_consumable_array/* default */.Z)(constants/* VIDEO_GA4_EVENT_PERCENTAGES */.Gl).reverse().find(function(percentage) {
                if (videoProgress >= parseInt(percentage)) {
                    return percentage;
                } else if (videoProgress === 99 && parseInt(percentage) === 100) {
                    // catch cases when videoProgress is 99.99 and 100% never reached
                    return "100";
                } else return null;
            });
            setCurrentPercentage(percentageToFire);
        }
    }, [
        videoProgress,
        pageviewEventHasFired
    ]);
    var getVideoData = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (_tmp.video_current_time = videoCurrentTime.toFixed(2), _tmp.video_duration = videoDuration.toFixed(2), _tmp.video_percent = 0, _tmp.video_provider = "sanity", _tmp.// NOTE: if some sanity videos doesn't have title -> send it as undefined
                video_title = !videoTitle ? undefined : videoTitle, _tmp.video_url = videoUrl, _tmp.visible = "".concat(true), _tmp)
            ];
        });
    }), [
        videoTitle,
        videoUrl,
        videoCurrentTime,
        videoDuration
    ]);
    (0,react.useEffect)(function() {
        // only call function to fire event when the current percentage changes (0, 10, 25, 50, 75, 100)
        if (pageviewEventHasFired) {
            if (currentPercentage !== undefined) {
                (0,ga4VideoEvents/* firePreviousAndCurrentGA4VideoEvents */._E)({
                    percentage: currentPercentage,
                    eventHasFired: eventHasFired,
                    setEventFired: setEventFired,
                    getVideoData: getVideoData,
                    onVideoStartCallback: onVideoStartCallback
                });
            }
        }
    // NOTE: do not add eventHasFired neither setEventFired to the dependencies array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPercentage,
        pageviewEventHasFired,
        getVideoData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test-id": "video-player-with-ga4-events",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: ref,
            onTimeUpdate: onTimeUpdate,
            onEnded: function() {
                return setCurrentPercentage("100");
            },
            children: children
        }))
    });
});
VideoPlayerWithGA4Events_Child.displayName = "VideoPlayerWithGA4Events_Child";

;// CONCATENATED MODULE: ./ui/components/Video.tsx




var Video = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var src = props.src, videoOptions = props.videoOptions, _className = props.className, className = _className === void 0 ? "zoom-video" : _className, _playsInline = props.playsInline, playsInline = _playsInline === void 0 ? true : _playsInline, muted = props.muted;
    var isMuted = Boolean(muted || videoOptions.muted);
    var videoRef = ref;
    var sourceRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var _$ref;
        // We need to manually change the `src`
        // After the initial server render the `src` never changes on the client
        // https://stackoverflow.com/questions/41303012/updating-source-url-on-html5-video-with-react
        if (!((_$ref = sourceRef.current) === null || _$ref === void 0 ? void 0 : _$ref.getAttribute("src")) && src) {
            var _$ref1, _$ref2;
            (_$ref1 = sourceRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.setAttribute("src", src);
            videoRef === null || videoRef === void 0 ? void 0 : (_$ref2 = videoRef.current) === null || _$ref2 === void 0 ? void 0 : _$ref2.load();
        }
    }, [
        src,
        videoRef,
        sourceRef
    ]);
    (0,react.useEffect)(function() {
        // React does not guarantee setting attributes on <video /> elements
        // https://github.com/facebook/react/issues/10389
        if ((videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) && videoRef.current.hasAttribute("muted") !== isMuted) {
            if (isMuted) {
                videoRef.current.setAttribute("muted", "");
            } else {
                videoRef.current.removeAttribute("muted");
            }
        }
    }, [
        videoOptions,
        videoRef,
        isMuted
    ]);
    (0,react.useEffect)(function() {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.current.load();
    }, [
        src,
        videoRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayerWithGA4Events, {
        ref: videoRef,
        className: (0,twind.tw)(className),
        controls: videoOptions.controls,
        autoPlay: videoOptions.autoPlay,
        loop: videoOptions.loop,
        muted: isMuted,
        playsInline: playsInline,
        controlsList: "nodownload",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            src: src,
            type: "video/mp4",
            "data-test-id": "video-source"
        })
    });
});
Video.displayName = "Video";


/***/ }),

/***/ 2254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34209);





var Container = function(_param) {
    var className = _param.className, _bleed = _param.bleed, bleed = _bleed === void 0 ? false : _bleed, _gutter = _param.gutter, gutter = _gutter === void 0 ? true : _gutter, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "bleed",
        "gutter"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,twind__WEBPACK_IMPORTED_MODULE_4__.tw)([
            "relative w-full",
            className,
            bleed ? "w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] px-0 sm:px-0" : "max-w-screen-3xl mx-auto",
            !bleed && gutter && "px-4 sm:px-8", 
        ]),
        "data-bleed": bleed
    }, props));
};


/***/ }),

/***/ 78615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_E": function() { return /* binding */ firePreviousAndCurrentGA4VideoEvents; }
/* harmony export */ });
/* unused harmony exports checkAndFireGA4VideoEvent, getLastVideoGA4Event, customExpectedVideoGA4Event */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59312);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83168);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);







var firePreviousAndCurrentGA4VideoEvents = function(param) {
    var percentage = param.percentage, eventHasFired = param.eventHasFired, setEventFired = param.setEventFired, getVideoData = param.getVideoData, onVideoStartCallback = param.onVideoStartCallback;
    var params = {
        setEventFired: setEventFired,
        eventHasFired: eventHasFired
    };
    var fireEvents = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(percentages) {
            var _videoData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getVideoData()
                        ];
                    case 1:
                        _videoData = _state.sent();
                        percentages.forEach(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(_percentage) {
                                var _tmp;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                                    if (_percentage === "0") onVideoStartCallback === null || onVideoStartCallback === void 0 ? void 0 : onVideoStartCallback();
                                    _tmp = {};
                                    checkAndFireGA4VideoEvent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_tmp.percentage = _percentage, _tmp.videoData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _videoData), {
                                        video_percent: parseInt(_percentage, 10)
                                    }), _tmp), params));
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(_percentage) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2
                        ];
                }
            });
        });
        return function fireEvents(percentages) {
            return _ref.apply(this, arguments);
        };
    }();
    switch(percentage){
        case "0":
            fireEvents([
                "0"
            ]);
            break;
        case "10":
            fireEvents([
                "0",
                "10"
            ]);
            break;
        case "25":
            fireEvents([
                "0",
                "10",
                "25"
            ]);
            break;
        case "50":
            fireEvents([
                "0",
                "10",
                "25",
                "50"
            ]);
            break;
        case "75":
            fireEvents([
                "0",
                "10",
                "25",
                "50",
                "75"
            ]);
            break;
        case "100":
            fireEvents([
                "0",
                "10",
                "25",
                "50",
                "75",
                "100"
            ]);
            break;
    }
};
var checkAndFireGA4VideoEvent = function(param) {
    var eventHasFired = param.eventHasFired, setEventFired = param.setEventFired, percentage = param.percentage, videoData = param.videoData;
    var eventName = "".concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .VIDEO_GA4_EVENT_PERCENTAGE_STRING */ .au[percentage], "-").concat(videoData.video_provider);
    var getEventName = function(percentage) {
        switch(percentage){
            case "0":
                return _analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.VIDEO_START */ ._q.VIDEO_START;
            case "100":
                return _analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.VIDEO_COMPLETE */ ._q.VIDEO_COMPLETE;
            default:
                return _analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.VIDEO_PROGRESS */ ._q.VIDEO_PROGRESS;
        }
    };
    if (!eventHasFired(eventName)) {
        (0,_analytics__WEBPACK_IMPORTED_MODULE_0__/* .event */ .B)(_analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
            event_name: getEventName(percentage),
            event_params: videoData
        });
        setEventFired(eventName);
    }
};
// ─── for storybook ──────────────────────────────────────────────────────────────────────────
var GA4_VIDEO_EVENT_NAMES = [
    _analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.VIDEO_START */ ._q.VIDEO_START,
    _analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.VIDEO_PROGRESS */ ._q.VIDEO_PROGRESS,
    _analytics__WEBPACK_IMPORTED_MODULE_0__/* .AnalyticsEvents.VIDEO_COMPLETE */ ._q.VIDEO_COMPLETE, 
];
var getLastVideoGA4Event = function() {
    var events = window.dataLayer.filter(function(e) {
        return GA4_VIDEO_EVENT_NAMES.includes(e.event_name);
    });
    var event = events[events.length - 1];
    var _ref = event === null || event === void 0 ? void 0 : event.event_params, _ = _ref.video_current_time, __ = _ref.video_duration, event_params // we only care about this values to compare
     = _object_without_properties(_ref, [
        "video_current_time",
        "video_duration"
    ]);
    return _object_spread_props(_object_spread({}, event), {
        event_params: event_params
    });
};
var customExpectedVideoGA4Event = function(param) {
    var event_name = param.event_name, video_percent = param.video_percent, eventData = param.eventData;
    return _object_spread_props(_object_spread({}, eventData), {
        event_name: event_name,
        event_params: _object_spread_props(_object_spread({}, eventData.event_params), {
            video_percent: parseInt(video_percent, 10)
        })
    });
};


/***/ })

}]);